"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.libs = void 0;
var _renderers = require("./renderers");
const libs = exports.libs = {
  backInStockNotification: _renderers.BackInStockNotification,
  basketBubble: _renderers.BasketBubble,
  basketProvider: _renderers.BasketProvider,
  errorNotification: _renderers.ErrorNotification,
  /** @deprecated Will be removed in the next major release */
  favoritesProvider: () => null,
  /** @deprecated Will be removed in the next major release */
  favoritesSubmenu: () => null,
  feedbackBenefitDialog: _renderers.FeedbackBenefitDialog,
  loyaltyDialog: _renderers.LoyaltyDialog,
  miniShoppingBag: _renderers.MiniShoppingBag,
  novageSkincareAdvisor: _renderers.NovageSkincareAdvisor,
  productInfoDialog: _renderers.ProductInfoDialog,
  subscriptionWizard: _renderers.SubscriptionWizard,
  qrCodeDialog: _renderers.QrCodeDialog,
  ratingAndReviewDialog: _renderers.RatingAndReviewDialog
};
